import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawIcon from "./RawChevronThinRightIcon.svg.jsx";

const ChevronThinRightIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawIcon} {...props} />;
});

export default ChevronThinRightIcon;
